(() => {
  if (window.dsrcvPdpMediaCounters) return;
  window.dsrcvPdpMediaCounters = true;

  const selector = '[data-pdp-media-counter-group]';
  const counters = new Map();

  function update(group, state) {
    const items = [...state.track.querySelectorAll(state.track.dataset.pdpMediaCounterItems)];
    state.counter.hidden = items.length < 2 || state.track.scrollWidth <= state.track.clientWidth + 2;
    if (state.counter.hidden) return;

    const bounds = state.track.getBoundingClientRect();
    const style = getComputedStyle(state.track);
    const rtl = style.direction === 'rtl';
    const start = rtl ? bounds.right - parseFloat(style.paddingRight || 0)
      : bounds.left + parseFloat(style.paddingLeft || 0);
    let selected = 0;
    let distance = Infinity;
    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const delta = Math.abs((rtl ? rect.right : rect.left) - start);
      if (delta < distance) {
        distance = delta;
        selected = index;
      }
    });
    const last = items[items.length - 1].getBoundingClientRect();
    const end = rtl ? bounds.left + parseFloat(style.paddingLeft || 0)
      : bounds.right - parseFloat(style.paddingRight || 0);
    if (state.track.scrollWidth > state.track.clientWidth + 2 &&
        Math.abs((rtl ? last.left : last.right) - end) <= 2) selected = items.length - 1;

    const text = `${selected + 1} / ${items.length}`;
    if (state.counter.textContent !== text) state.counter.textContent = text;
  }

  function init(group) {
    const existing = counters.get(group);
    if (existing) return existing.schedule();
    const track = group.querySelector('[data-pdp-media-counter-track]');
    const counter = group.querySelector('[data-pdp-media-counter]');
    if (!track || !counter || !track.dataset.pdpMediaCounterItems) return;
    const state = {track, counter, frame: 0};
    state.schedule = () => {
      if (state.frame) return;
      state.frame = requestAnimationFrame(() => {
        state.frame = 0;
        if (group.isConnected) update(group, state);
      });
    };
    track.addEventListener('scroll', state.schedule, {passive: true});
    if (window.ResizeObserver) {
      state.resize = new ResizeObserver(state.schedule);
      state.resize.observe(track);
    }
    counters.set(group, state);
    update(group, state);
  }

  function scan(root) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  }

  function refresh() {
    counters.forEach((state, group) => {
      if (group.isConnected) return state.schedule();
      state.track.removeEventListener('scroll', state.schedule);
      state.resize?.disconnect();
      cancelAnimationFrame(state.frame);
      counters.delete(group);
    });
  }

  function start() {
    scan(document);
    window.addEventListener('resize', refresh, {passive: true});
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', refresh);
    new MutationObserver(records => {
      refresh();
      records.forEach(record => {
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1) scan(node);
        });
        const group = record.target.closest?.(selector);
        if (group) init(group);
      });
    }).observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
